import script from "./a-exp.vue?vue&type=script&setup=true&lang=js"
export * from "./a-exp.vue?vue&type=script&setup=true&lang=js"

import "./a-exp.vue?vue&type=style&index=0&id=589e7724&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589e7724"]])

export default __exports__